import { defineStore } from 'pinia'
import axios from 'axios'

export const useAppointmentRequestStore = defineStore('appointmentStore', {
    state: () => ({
    }),

    actions: {
        async postAppointment(payload) {
            try {
                const response = await axios.post('/appointment', payload)
                if (response.status === 200 || response.status === 201) {
                    console.log('POST: ', response.data);
                    return response.data
                } else {
                    throw new Error(`POST failed :${response.statusText}`)
                }
            } catch (error) {
                console.error('post appointmentStore error:', error)
                throw error
            }
        },

        async updateAppointment(id, payload) {
            try {
                const response = await axios.post(`/appointment/${id}`, payload)
                if (response.status === 200 || response.status === 201) {
                    console.log('UPDATE: ', response.data);
                    return response
                } else {
                    throw new Error(`POST failed :${response.statusText}`)
                }
            } catch (error) {
                console.error('post appointmentStore error:', error)
                throw error
            }
        },

        async getAppointmentToday(query) {
            try {
                const response = await axios.get('/appointment-daily', { params: query })
                if (response.status === 200) {
                    console.log('GET getAppointmentToday :', response.data)
                    return response.data
                } else {
                    throw new Error(`GET failed: ${response.statusText}`)
                }
            } catch (error) {
                console.error('get appointmentStore error:', error)
                throw error
            }
        },

        async getAppointmentMonth(query) {
            try {
                const response = await axios.get('/appointment-month', { params: query })
                if (response.status === 200) {
                    console.log('GET getAppointmentMonth :', response.data)
                    return response.data
                } else {
                    throw new Error(`GET failed: ${response.statusText}`)
                }
            } catch (error) {
                console.error('get appointmentStore error:', error)
                throw error
            }
        },

        async deleteAppointment(id) {
            try {
                const response = await axios.delete(`/appointment/${id}`)
                if (response.status === 200 || response.status === 201) {
                    console.log('DELETE: ', response.data);
                    return response
                } else {
                    throw new Error(`DELETE failed :${response.statusText}`)
                }
            } catch (error) {
                console.error('DELETE appointmentStore error:', error)
                throw error
            }
        },

        async SearchAppointment(query) {
            try {
                const response = await axios.get(`/appointment-month`,{ params: query })
                if (response.status === 200 ) {
                    console.log('GET: ', response.data);
                    return response.data
                } else {
                    throw new Error(`GET failed :${response.statusText}`)
                }
            } catch (error) {
                console.error('GET appointmentStore error:', error)
                throw error
            }
        },

        async getShelter(id,  query = {}) {
            try {
                const response = await axios.get(`/shelter/${id}`, { params: query } )
                if (response.status === 200) {
                    console.log('GET getShelter :', response.data)
                    return response.data
                } else {
                    throw new Error(`GET failed: ${response.statusText}`)
                }
            } catch (error) {
                console.error('get getShelter error:', error)
                throw error
            }
        },

        async getTeams(id,  query = {}) {
            try {
                const response = await axios.get(`/team/${id}`, { params: query } )
                if (response.status === 200) {
                    console.log('GET getTeams :', response.data)
                    return response.data
                } else {
                    throw new Error(`GET failed: ${response.statusText}`)
                }
            } catch (error) {
                console.error('get getTeams error:', error)
                throw error
            }
        },
    }
})